import { createSlice } from "@reduxjs/toolkit";
import { ModalType } from "constants/enums";

const initialState = {
    value: { isOpen: false, modalType: ModalType.Default  }
}

const initialComponentState = {
    value: true
}

const modalActionsSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openOrCloseModal: (state, action) => {
            state.value = action.payload
        }
    }
})

const modalComponentSlice = createSlice({
    name: 'modal',
    initialState: initialComponentState,
    reducers: {
        showModalHeader: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { openOrCloseModal } = modalActionsSlice.actions;
export const { showModalHeader } = modalComponentSlice.actions;
export default {
    modalActionsSlice: modalActionsSlice.reducer,
    modalComponentSlice: modalComponentSlice.reducer
}